import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../i18n';
import {sdoNs} from '../constants-enumerate';
import {storeInstance} from '@aofl/store/dist/legacy';
import SessionActions from '../session-sdo';
import '../sdo-user-jobs';
import './sdo';

/**
 * @summary SiteHeader
 * @extends {i18nMixin(AoflElement)}
 */
@customElement('site-header')
class SiteHeader extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of SiteHeader.
   */
  constructor() {
    super();

    this.storeInstance = storeInstance;
    this.translations = translations;
  }

  /**
   * @readonly
   */
  static get is() {
    return 'site-header';
  }

  @property({type: Boolean, attribute: false, mapState: `${sdoNs.SESSION}.loggedIn`, store: storeInstance})
  loggedIn = false;

  @property({type: Boolean, attribute: false, mapState: `${sdoNs.SESSION}.$routeToLanding`, store: storeInstance})
  routeToLanding = false;

  @property({type: Boolean, attribute: false, mapState: `${sdoNs.LAYOUT}.showMenu`, store: storeInstance})
  showMenu = true;

  @property({type: String, attribute: false, mapState: `${sdoNs.SITE_HEADER}.backBtnUrl`, store: storeInstance})
  backBtnUrl = null;

  @property({type: String, attribute: false, mapState: `${sdoNs.SITE_HEADER}.title`, store: storeInstance})
  title = null;

  @property({type: String, attribute: false, mapState: `${sdoNs.SESSION}.name`, store: storeInstance})
  username = '';

  @property({type: String, attribute: false, mapState: `${sdoNs.SESSION}.type`, store: storeInstance})
  userType = '';

  @property({type: Number, mapState: `${sdoNs.USER_JOBS}.$activeJobs.length`, store: storeInstance})
  userJobCount = 0;

  @property({type: Number, mapState: `${sdoNs.SESSION}.id`, store: storeInstance})
  userId = 0;

  @property({type: Object, attribute: false, mapState: `${sdoNs.SESSION}.current_role`, store: storeInstance})
  currentRole = {};

  @property({type: Number, mapState: `${sdoNs.USER_JOBS}.$unseenCount`, store: storeInstance})
  jobscount = 0;

  @property({type: Array, mapState: `${sdoNs.USER_JOBS}.$notificationBellJobs`, store: storeInstance})
  jobs = [];

  @property({type: Object, attribute: false, mapState: `${sdoNs.SESSION}.settings`, store: storeInstance})
  settings = {};

  @property({type: Object, attribute: false, mapState: `${sdoNs.SESSION}.selectedGroup`, store: storeInstance})
  selectedGroup = {};

  @property({type: Boolean, attribute: false, mapState: `${sdoNs.SESSION}.$isRootAdmin`, store: storeInstance})
  isRootAdmin;

  @property({type: String, attribute: false, mapState: `${sdoNs.SESSION}.$orgType`, store: storeInstance})
  orgType;

  setSeenJobs() {
    const ids = [];

    this.jobs.forEach((job) => {
      ids.push(job.id);
    });

    storeInstance.commit({
      namespace: sdoNs.USER_JOBS,
      mutationId: 'setSeenJobs',
      payload: ids
    });
  }

  logout() {
    setTimeout(() => {
      SessionActions.logout();
    }, 150); /** @todo temporary hack - wait for drawer to close */
  }

  onLeftPanelCloseByKey() {
    const mobileMediaQuery = window.matchMedia('(max-width: 767px)');
    const smallWindow = mobileMediaQuery.matches;
    if (smallWindow) {
      this.shadowRoot.querySelector('side-panel-button').querySelector('span[tabindex="0"]')?.focus();
    }
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {
        template,
        styles: [styles]
      }
    });
  }
}

export default SiteHeader;
